import { Grid } from '@mui/material'
import { C1AppUsersList, AppUserListColumns } from 'components/core/app-user/C1AppUsersList'
import { SelectOneAppHook } from 'components/core/search/apps'
import { SelectOneUserHook } from 'components/core/search/users'
import { StructuredSearchStyles } from 'components/pages/explore/query/styles'
import { AppValue } from 'lib/actions/apps'
import { UserValue } from 'lib/actions/user'
import { AppUserServiceSearchRequest } from 'pbts/c1/api/app/v1/app_user'
import { FC, useCallback, useState } from 'react'

export const AllAppUsersReport: FC = () => {
    const [filter, setFilter] = useState<Partial<AppUserServiceSearchRequest>>({})

    const onSelectedApp = useCallback((a: AppValue | null): void => {
        setFilter((prev) => ({ ...prev, appId: a?.id || '' }))
    }, [])

    const onSelectedUser = useCallback((u: UserValue | null): void => {
        setFilter((prev) => ({ ...prev, userIds: u ? [u.id] : [] }))
    }, [])

    return <>
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
            sx={StructuredSearchStyles.filterInputs}
        >
            <Grid item sm={12} md={4} key="select-app-container">
                <SelectOneAppHook onSelected={onSelectedApp} initAppId={filter.appId} />
            </Grid>
            <Grid item sm={12} md={4} key="select-user-container">
                <SelectOneUserHook onSelected={onSelectedUser} initUserId={filter.userIds?.[0]} />
            </Grid>
        </Grid>

        <C1AppUsersList
            columns={[
                AppUserListColumns.account,
                AppUserListColumns.app,
                AppUserListColumns.status,
                AppUserListColumns.accountType,
                AppUserListColumns.user,
                AppUserListColumns.roles,
                AppUserListColumns.lastLogin,
                AppUserListColumns.actions,
            ]}
            filter={filter}
            displayFilters={['query']}
            allowExport
        />
    </>
}
